/**
 * ============================================================================
 * DELIVERY APPROVAL PAGE - 100% Ready
 * ============================================================================
 * 
 * Buyer Reviews Delivery
 */

import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { UserDashboardLayout } from '../components/user';
import DeliveryApproval from '../components/delivery/DeliveryApproval';
import Button from '../components/common/Button';
import { useI18n } from '../providers';

/**
 * Delivery Approval Page
 * @returns {JSX.Element}
 */
const DeliveryApprovalPage = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const { language } = useI18n();

  const handleSuccess = () => {
    navigate(`/transactions/${id}`);
  };

  return (
    <UserDashboardLayout>
      {/* Header */}
      <div className="mb-8 animate-fadeInUp">
        <Button
          variant="ghost"
          size="sm"
          onClick={() => navigate(`/transactions/${id}`)}
          className="mb-4"
        >
          ← {language === 'fr' ? 'Retour à la transaction' : 'Back to Transaction'}
        </Button>
        <h1 className="text-4xl font-black bg-gradient-to-r from-blue-600 to-green-600 bg-clip-text text-transparent mb-2">
          📦 {language === 'fr' ? 'Révision de livraison' : 'Delivery Review'}
        </h1>
        <p className="text-gray-600 dark:text-gray-400 text-lg">
          {language === 'fr'
            ? 'Examinez la livraison et approuvez ou soulevez un problème'
            : 'Review the delivery and approve or raise an issue'}
        </p>
      </div>

      {/* Delivery Approval Component */}
      <div className="animate-fadeInUp" style={{ animationDelay: '0.1s' }}>
        <DeliveryApproval transactionId={id} onSuccess={handleSuccess} />
      </div>
    </UserDashboardLayout>
  );
};

export default DeliveryApprovalPage;
